import $ from 'jquery';

if( $( ".js-pinned-header" ).length > 0 ) {

	var s = $( ".js-pinned-header" );
	var pos = s.position();

	$( window ).scroll( function() {
		var windowpos = $(window).scrollTop();
		if ( windowpos >= pos.top & windowpos <= 0 ) {
			s.addClass( "c-header--transparent" );
		} else {
			s.removeClass( "c-header--transparent" );
		}
	} );

}

$( '.js-hamburger-icon' ).on( 'click', function() {
	$( '.c-header--transparent' ).toggleClass( 'is-expanded' );
} );
